import { Phone, MessageCircle } from "lucide-react";
import { STORE, waLink, telLink } from "@/lib/store";

export default function StickyMobileCTAs() {
    return (
        <div
            data-testid="sticky-mobile-ctas"
            className="fixed bottom-4 left-4 right-4 z-50 md:hidden"
        >
            <div className="grid grid-cols-2 gap-3">
                <a
                    href={telLink()}
                    data-testid="sticky-call-btn"
                    className="flex items-center justify-center gap-2 h-12 rounded-full bg-charcoal text-white font-semibold shadow-lg shadow-black/20 active:scale-[0.98] transition-transform"
                >
                    <Phone className="w-4 h-4" />
                    Call now
                </a>
                <a
                    href={waLink()}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="sticky-whatsapp-btn"
                    className="flex items-center justify-center gap-2 h-12 rounded-full bg-safety text-white font-semibold shadow-lg shadow-safety/40 active:scale-[0.98] transition-transform"
                >
                    <MessageCircle className="w-4 h-4" />
                    WhatsApp
                </a>
            </div>
        </div>
    );
}
